// extracted by mini-css-extract-plugin
export default {"statusIcons":"fYMhahJgYm"};